<template>
  <b-row>
    <b-col>
      <b-form-group label="License Plate">
        <b-form-input v-model="form.licensePlate" />
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group label="Reservation No">
        <b-form-input v-model="form.reservationId" />
      </b-form-group>
    </b-col>
    <b-col>
      <b-form-group label="Date Range">
        <DatePicker v-model="form.dateRange" v-bind="dateOptions" />
      </b-form-group>
    </b-col>
    <b-col>
      <b-btn
        v-if="form.licensePlate || form.reservationId || form.dateRange.length"
        style="margin-top: 25px"
        variant="success"
        @click="handleSearch">
        Search
      </b-btn>
      <b-btn
        v-if="form.licensePlate || form.reservationId || form.dateRange.length"
        style="margin-top: 25px; margin-left: 1rem"
        variant="secondary"
        @click="handleReset">
        Reset
      </b-btn>
    </b-col>
  </b-row>
</template>

<script>
import DatePicker from 'vue2-datepicker'
import moment from 'moment'

export default {
  name: 'SearchForm',
  components: {
    DatePicker
  },
  data() {
    return {
      dateOptions: {
        format: 'YYYY-MM-DD',
        type: 'date',
        range: true,
        'range-separator': '-',
        lang: 'en',
        shortcuts: false
      },
      form: {
        licensePlate: undefined,
        reservationId: undefined,
        dateRange: []
      }
    }
  },
  created() {
    const { query } = this.$route
    if (query.reservationStart) {
      this.form.dateRange.push(query.reservationStart)
    }
    if (query.reservationEnd) {
      this.form.dateRange.push(query.reservationEnd)
    }
    if (query.licensePlate) {
      this.form.licensePlate = query.licensePlate
    }
    if (query.reservationId) {
      this.form.reservationId = query.reservationId
    }
    if (query.transmissionStatus) {
      this.form.transmissionStatus = query.transmissionStatus
    }
  },
  methods: {
    handleSearch() {
      const payload = {}
      if (this.form.licensePlate) {
        payload.licensePlate = this.form.licensePlate
      }
      if (this.form.reservationId) {
        payload.reservationId = this.form.reservationId
      }
      if (this.form.dateRange.length) {
        const start = moment(this.form.dateRange[0]).format('YYYY-MM-DD')
        const end = moment(this.form.dateRange[1]).format('YYYY-MM-DD')
        payload.reservationStart = `${start} 00:00`
        payload.reservationEnd = `${end} 23:59`
      }
      this.$emit('search', payload)
    },
    handleReset() {
      this.form.licensePlate = undefined
      this.form.reservationId = undefined
      this.form.dateRange = []
      this.form.transmissionStatus = undefined
      this.$emit('reset')
    }
  }
}
</script>

<style>

</style>